/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { UserProfileContext } from 'auth/contexts/UserProfileContext';

import { SEARCH_REDUCERS } from 'state/reducers/search/searchReducers';
import { AUTOCOMPLETE_REDUCERS } from 'state/reducers/autocomplete/autocompleteReducers';

import { tagTokenPrefix } from 'state/services/searchApiUtils';
import PatientSearchField from 'views/components/Search/PatientSearchField';
import PatientSearchForm from './PatientSearchForm';
import {
  updateSelectedFilterDropdown,
  searchSubmit,
  paginationTokenClear,
  getKardiaRxCCTWorklistData,
  slectedValueONSubmitClear,
} from '../../state/kardiaRxCCTWorklist/KardiaRxCCTWorklistActions';

import styles from './PatientSearchBar.css';

class PatientSearchBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchType: '',
      searchParams: {
        page: 1,
      },
      tagRemoved: null,
    };
  }

  handleSearchTypeChange = searchType => {
    this.props.paginationTokenClear();
    this.setState(
      {
        searchType,
      },
      () => {
        this.props.updateSelectedFilterDropdown(searchType);
      },
    );
  };

  handleSubmit = values => {
    this.props.paginationTokenClear();
    if (values && values.patients) {
      const valueArray = values.patients.split(' [');
      const mrnIdentifier =
        valueArray[1] && valueArray[1].substring(0, valueArray[1].length - 1);
      if (mrnIdentifier) {
        const mrnValue = mrnIdentifier.split(':')[1];
        // console.log('values on submit mrn =>', mrnValue);
        // this.props.getKardiaRxPatientsData(false, mrnValue);
        this.props.getKardiaRxCCTWorklistData(
          false,
          this.props.cctDropdownValue ? this.props.cctDropdownValue : 1,
          100,
          1,
          '',
          mrnValue,
        );
      } else {
        // console.log('values on submit mrn not match =>', values.patients);
        // this.props.getKardiaRxPatientsData(false, values.patients);
        this.props.getKardiaRxCCTWorklistData(
          false,
          this.props.cctDropdownValue ? this.props.cctDropdownValue : 1,
          100,
          1,
          '',
          values.patients,
        );
      }
    } else {
      this.props.getKardiaRxCCTWorklistData(
        false,
        this.props.cctDropdownValue ? this.props.cctDropdownValue : 1,
        100,
        1,
        '',
      );
    }
    this.props.searchSubmit(values);
  };

  handleRemoveTag = (field, value) => {
    // console.log('Tag Remove');
    this.props.paginationTokenClear();
    this.props.slectedValueONSubmitClear();
    this.props.getKardiaRxCCTWorklistData(
      false,
      this.props.cctDropdownValue ? this.props.cctDropdownValue : 1,
      100,
      1,
      '',
    );
  };

  onFormChange = (values, previousValues) => {};

  render() {
    const { searchType, searchParams } = this.state;
    const { patientSearchResults, autocompleteResults } = this.props;
    // const { participants } = autocompleteResults;

    const autocompleteLoading = autocompleteResults.isFetching === true;
    return (
      <div>
        <PatientSearchForm
          onFormChange={this.onFormChange}
          selectedSearchType={searchType}
          selectedOptionValues={this.props.selectedOptionValues}
          styles={styles}
          isSubmitting={patientSearchResults.isFetching === true}
          onSubmit={this.handleSubmit}
          onSearchTypeChange={this.handleSearchTypeChange}
          searchFieldComponent={
            <PatientSearchField
              placeholder="Patient name / MRN"
              isLoading={autocompleteLoading}
              autocompleteData={autocompleteResults}
              styles={styles}
              defaultValue={searchParams.patients}
              tokenPrefix={tagTokenPrefix}
              onRemoveTag={this.handleRemoveTag}
            />
          }
        />
      </div>
    );
  }
}
PatientSearchBar.contextType = UserProfileContext;

// setup up redux search store
const mapStateToProps = ({ search, autocomplete, kardiaRx }) => {
  return {
    patientSearchResults: search[SEARCH_REDUCERS.INFINITE_SCROLL_REDUCER],
    autocompleteResults:
      kardiaRx.kardiaRxCCTWorklist.worklistCCTAutoCompleteSearch,
    autocompleteForceRefresh:
      autocomplete[AUTOCOMPLETE_REDUCERS.AUTOCOMPLETE_FORCE_REFRESH],
    selectedOptionValues: kardiaRx.kardiaRxCCTWorklist.filterDropdownlist.data,
    cctDropdownValue: kardiaRx.kardiaRxCCTWorklist.selectedFilterDropdown,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    updateSelectedFilterDropdown,
    searchSubmit,
    paginationTokenClear,
    getKardiaRxCCTWorklistData,
    slectedValueONSubmitClear,
  })(PatientSearchBar),
);



// WEBPACK FOOTER //
// ./src/views/containers/WorkListSearch/PatientSearchBar.jsx